export default "__VITE_ASSET__7aca8581__"